"use client";

import { useEffect, useState } from "react";
import { WebviewTenant } from '@enums/webview-tenant';
import { genericWebviewHandler, WebViewActions } from "@utils/client/webview";
import { TenantActionValue, TenantPageConfig } from "@config/webview-tenant-config";
import Cookies from 'js-cookie';

interface IWebviewParams {
    tenant?: WebviewTenant;
    tenantPage?: string;

}


export const WebviewInitializer = ({ tenant = WebviewTenant.AIRPASS, tenantPage }: IWebviewParams) => {
    const [nativeHeaderHeight, setNativeHeaderHeight] = useState<number>(64);
    useEffect(() => {
        const initializeWebview = () => {
            genericWebviewHandler({
                action: WebViewActions.UPDATE_APP_BAR,
                action_value: tenantPage ? TenantPageConfig[tenant]?.[tenantPage]?.action_value : TenantActionValue[tenant]
            });

            if (tenantPage) {
                setNativeHeaderHeight(TenantPageConfig[tenant]?.[tenantPage]?.top_margin_value);
            } else setNativeHeaderHeight(parseFloat(Cookies.get('native_header_height') || '64') - 20);
        }
        initializeWebview();
    }, []);

    if(tenantPage && TenantPageConfig[tenant]?.[tenantPage]?.is_top_margin_required){
        return <div style={{paddingTop: `${Cookies.get('native_header_height') || '0'}px`}}/>
    }
    return null;
}
